import React from "react";
import s from "../../admin_styles/UserSearch.module.css";

export default function Pagination({ page, totalPages, onPageChange,  totaltext}) {
  const getPageNumbers = () => {
    if (totalPages <= 10) {
      return [...Array(totalPages).keys()].map(n => n + 1);
    }

    let startPage = Math.max(page - 5, 1);
    let endPage = startPage + 9;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(endPage - 9, 1);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };

  return (
    <div className={s.pagination}>
      <button onClick={() => onPageChange(Math.max(1, page - 1))} disabled={page === 1}>
        Назад
      </button>

      {getPageNumbers().map(num => (
        <button
          key={num}
          onClick={() => onPageChange(num)}
          className={num === page ? s.activePage : ""}
        >
          {num}
        </button>
      ))}

      <button onClick={() => onPageChange(Math.min(totalPages, page + 1))} disabled={page === totalPages}>
        Вперёд
      </button>
      <p>{totaltext}</p>
    </div>
  );
}
